import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { FilterComponent } from '@app/layout/filter/filter.component';
import { FilterOptions } from '@app/layout/filter/interfaces/filter-options';
import { GallerySelectors, SetSortingOptionsValue } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { SortingOptionsValues } from './sorting-options-values';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationExtras } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';

@Component({
  selector: 'app-sorting-options',
  templateUrl: './sorting-options.component.html',
  styleUrls: ['./sorting-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FilterComponent],
})
export class SortingOptionsComponent implements OnInit {
  constructor(
    private store: Store,
    private destroyRef: DestroyRef,
  ) {}

  // Value
  protected ordering$: Observable<SortingOptionsValues> = this.store.select(
    GallerySelectors.ordering,
  );

  // Options
  protected options: FilterOptions<SortingOptionsValues> = new Map([
    [SortingOptionsValues.LATEST, 'Latest'],
    [SortingOptionsValues.POPULAR, 'Popular'],
  ]);

  protected SortingOptionsValues = SortingOptionsValues;

  ngOnInit(): void {
    this.ordering$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((ordering: SortingOptionsValues) => {
          const extras: NavigationExtras = {
            queryParams: ordering ? { ordering } : { ordering: null },
            queryParamsHandling: 'merge',
          };
          this.store.dispatch(new Navigate([], [], extras));
        }),
      )
      .subscribe();
  }

  protected onSetSortingOptionsValue(value: string): void {
    this.store.dispatch(
      new SetSortingOptionsValue(value as SortingOptionsValues),
    );
  }
}
